import {useState} from 'react'
import {Text} from '@/components/atoms'
import {useGetGTINDetails} from '@/hooks/promotion/useGetGTINDetails'
import {CustomDataTable} from '@/components/organisms'
import {GTINDetailsListColConfig} from '@/services/MockData/Promotions/ProductTableColumns'
import {DEFAULT_TABLE_PAGE_SIZE, SELECTION_TYPE} from '@/utils/constants/commonConstants'

export const GTINSTable = ({currentSelectedGtin}) => {
  const [pageIndex, setPageIndex] = useState(0)
  const {data, isLoading} = useGetGTINDetails(currentSelectedGtin, pageIndex)

  const tableData = data?.data || []

  const handleNextPage = (nextPage) => {
    setPageIndex(nextPage - 1)
  }

  if (!currentSelectedGtin) {
    return (
      <div className="flex flex-1 items-center justify-center p-4">
        <Text>{'No data selected'}</Text>
      </div>
    )
  }

  return (
    <div className="flex-1 p-4">
      <Text headingLevel={4} variant={'bold'} isDark>
        {currentSelectedGtin}
      </Text>
      <CustomDataTable
        columns={GTINDetailsListColConfig}
        records={tableData}
        isLoading={isLoading}
        pageSize={DEFAULT_TABLE_PAGE_SIZE}
        totalRecords={data?.totalRecords}
        setPageIndex={handleNextPage}
        showResetAll={false}
        enableSelection={false}
        showColumnFilters={false}
      />
    </div>
  )
}
